(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[120],{

/***/ 95759:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...slug]]",
      function () {
        return __webpack_require__(79602);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 79602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/loaders/LoadingAnimation.tsx

var LoadingAnimation = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: 44,
        height: 44,
        xmlns: "http://www.w3.org/2000/svg",
        stroke: "#666",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            strokeWidth: 2,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("circle", {
                    cx: 22,
                    cy: 22,
                    r: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                            attributeName: "r",
                            begin: "0s",
                            dur: "1.8s",
                            values: "1; 20",
                            calcMode: "spline",
                            keyTimes: "0; 1",
                            keySplines: "0.165, 0.84, 0.44, 1",
                            repeatCount: "indefinite"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                            attributeName: "stroke-opacity",
                            begin: "0s",
                            dur: "1.8s",
                            values: "1; 0",
                            calcMode: "spline",
                            keyTimes: "0; 1",
                            keySplines: "0.3, 0.61, 0.355, 1",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("circle", {
                    cx: 22,
                    cy: 22,
                    r: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                            attributeName: "r",
                            begin: "-0.9s",
                            dur: "1.8s",
                            values: "1; 20",
                            calcMode: "spline",
                            keyTimes: "0; 1",
                            keySplines: "0.165, 0.84, 0.44, 1",
                            repeatCount: "indefinite"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                            attributeName: "stroke-opacity",
                            begin: "-0.9s",
                            dur: "1.8s",
                            values: "1; 0",
                            calcMode: "spline",
                            keyTimes: "0; 1",
                            keySplines: "0.3, 0.61, 0.355, 1",
                            repeatCount: "indefinite"
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/module/Wrapper.tsx
var Wrapper = __webpack_require__(83118);
// EXTERNAL MODULE: ./layout/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(47024);
// EXTERNAL MODULE: ./layout/Nav/Nav.tsx + 4 modules
var Nav = __webpack_require__(43172);
;// CONCATENATED MODULE: ./layout/pages/LoadingPage.tsx






var LoadingPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* Nav */.J, {
                items: [],
                buttons: [],
                showSearch: false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper/* Wrapper */.i, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingAnimation, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* Footer */.$, {
                links: [],
                socials: [],
                copyright: ""
            })
        ]
    });
};

// EXTERNAL MODULE: ./layout/pages/Page.tsx + 10 modules
var Page = __webpack_require__(74613);
;// CONCATENATED MODULE: ./pages/[[...slug]].tsx





var SlugPage = function(param) {
    var config = param.config, navigation = param.navigation, footer = param.footer, page = param.page, preview = param.preview, sitemap = param.sitemap, sitemapItem = param.sitemapItem, locked = param.locked;
    var router = (0,next_router.useRouter)();
    if (!page || router.isFallback) return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingPage, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* Page */.T, {
        navigation: navigation,
        page: page,
        preview: preview,
        footer: footer,
        config: config,
        sitemap: sitemap,
        sitemapItem: sitemapItem,
        locked: locked
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (SlugPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [648,613,774,888,179], function() { return __webpack_exec__(95759); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);